// extracted by mini-css-extract-plugin
module.exports = {"table-header":"Table_table-header__3QoCo","table-cell-data":"Table_table-cell-data__3EfoA"};